import { useHeatReportContext } from "@/pages/heat-report/context/HeatReportContext";
import { useTableStyles } from "@/pages/heat-report/styles/useTableStyles";
import { Box, Paper } from "@material-ui/core";
import { AgGridReact } from "ag-grid-react";
import { useTableData } from "./useTableData";

export const ScrapTable = () => {
	const classes = useTableStyles();
	const {
		state: { scrapData },
	} = useHeatReportContext();

	const { columns, rowData } = useTableData({ scrapData });

	return (
		<>
			<Paper className={classes.borderAgGridTable} elevation={0}>
				<Box p={0}>
					<div style={{ height: "11rem" }}>
						<AgGridReact
							rowData={rowData}
							columnDefs={columns}
							domLayout="normal"
							suppressRowClickSelection={true}
							suppressPaginationPanel={true}
							getRowId={(params) => params.data.id}
							suppressContextMenu
						/>
					</div>
				</Box>
			</Paper>
		</>
	);
};
